module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [(_vm.process !== 'next_actions') ? _c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body portlet-overflow"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createLocation($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.process === 'step_1') ? _c('div', {
    key: "step_1"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLocation.location_name),
      expression: "newLocation.location_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newLocation.location_name.length
    },
    attrs: {
      "type": "text",
      "id": "create_location_name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newLocation.location_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newLocation, "location_name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_location_name"
    }
  }, [_vm._v("Location Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLocation.unoapp_defined_name),
      expression: "newLocation.unoapp_defined_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newLocation.unoapp_defined_name.length
    },
    attrs: {
      "type": "text",
      "id": "create_unoapp_defined_name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newLocation.unoapp_defined_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newLocation, "unoapp_defined_name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_unoapp_defined_name"
    }
  }, [_vm._v("UNOapp Reference Name")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The client will not see this name but can be used for internal reference.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLocation.store_number),
      expression: "newLocation.store_number",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newLocation.store_number
    },
    attrs: {
      "type": "number",
      "id": "create_location_store_number"
    },
    domProps: {
      "value": (_vm.newLocation.store_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newLocation, "store_number", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_location_store_number"
    }
  }, [_vm._v("Store Number "), _c('small', {
    staticClass: "font-grey-cascade"
  }, [_vm._v("(optional)")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLocation.salesforce_id),
      expression: "newLocation.salesforce_id",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newLocation.salesforce_id
    },
    attrs: {
      "type": "text",
      "id": "create_location_salesforce"
    },
    domProps: {
      "value": (_vm.newLocation.salesforce_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newLocation, "salesforce_id", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_location_salesforce"
    }
  }, [_vm._v("Salesforce ID "), _c('small', {
    staticClass: "font-grey-cascade"
  }, [_vm._v("(optional)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
    key: "create-location-continue-one",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_2', 'step_1')
      }
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
    key: "step_2"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('google-places-search', {
    attrs: {
      "passedValue": _vm.newLocation.location_name,
      "confirmationMessage": _vm.confirmationMessage,
      "currentSelectedLocation": _vm.newLocation.selected_location
    },
    on: {
      "selectedLocation": _vm.selectedLocationUpdated
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "create-location-continue-one",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_3', 'step_2')
      }
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
    key: "step_3"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('google-maps-pin-confirmation', {
    attrs: {
      "passedValue": _vm.newLocation.selected_location
    },
    on: {
      "updateLocationLatLng": _vm.locationLatLngUpdated
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "create-location-continue-one",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_4', 'step_3')
      }
    }
  }, [_vm._v("Confirm & Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_4') ? _c('div', {
    key: "step_5"
  }, [(!_vm.regions.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v("Regions are required to set up locations.")])]) : _vm._e(), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.loadingRegionData,
      "color": '#3598dc',
      "display": 'inline'
    }
  }), _vm._v(" "), (!_vm.regions.length && _vm.loadingRegionData === false) ? _c('div', {
    staticClass: "mt-element-list mt-element-overflow"
  }, [_c('div', {
    staticClass: "mt-list-container list-default no-border"
  }, [_c('ul', [_c('li', {
    staticClass: "mt-list-item"
  }, [_c('div', {
    staticClass: "list-icon-container done"
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-globe"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "list-item-content"
  }, [_c('h3', {
    staticClass: "uppercase bold"
  }, [_c('router-link', {
    attrs: {
      "to": "/app/my_business/regions"
    }
  }, [_vm._v("Go to the regions dashboard")])], 1), _vm._v(" "), _c('p', [_c('small', [_vm._v("Regions can be used to assign users as admins to groups of locations we well as to market location based content to a group of locations.")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.regions.length && _vm.loadingRegionData === false) ? _c('div', [_c('div', {
    staticClass: "mt-element-list"
  }, [_c('div', {
    staticClass: "mt-list-container list-simple ext-1 group no-border"
  }, [(_vm.regionPath.length) ? _c('a', {
    staticClass: "list-toggle-container",
    on: {
      "click": function($event) {
        _vm.goUpOneLevel()
      }
    }
  }, [_c('div', {
    staticClass: "list-toggle not-selected"
  }, [_c('span', {
    staticClass: "fa fa-chevron-left margin-right-10"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tGo back to " + _vm._s(_vm.regionPath.length > 1 ? _vm.regionPath[_vm.regionPath.length - 2].name : 'base regions') + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedRegions), function(region) {
    return [_c('a', {
      staticClass: "list-toggle-container",
      on: {
        "click": function($event) {
          _vm.selectRegion(region)
        }
      }
    }, [_c('div', {
      staticClass: "list-toggle uppercase",
      class: {
        'not-selected': _vm.newLocation.region.id !== region.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), (region.has_children) ? _c('span', {
      staticClass: "pull-right fa fa-chevron-right"
    }) : _vm._e()])])]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.regions.length && _vm.loadingRegionData === false) ? _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "create-location-continue-one",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_5', 'step_4')
      }
    }
  }, [_vm._v("Confirm & Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.process === 'step_5') ? _c('div', {
    key: "step_5"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "margin-top-20 portlet-title-alternate"
  }, [_vm._v("Build a Product Package")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20 row search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click font-grey-mint"
  }, [_vm._v("Include App")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "md-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (app.location_access),
        expression: "app.location_access"
      }],
      staticClass: "md-check",
      attrs: {
        "type": "checkbox",
        "id": ("app_access_location_" + (app.app_id))
      },
      domProps: {
        "checked": Array.isArray(app.location_access) ? _vm._i(app.location_access, null) > -1 : (app.location_access)
      },
      on: {
        "change": function($event) {
          var $$a = app.location_access,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (app.location_access = $$a.concat([$$v]))
            } else {
              $$i > -1 && (app.location_access = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(app, "location_access", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("app_access_location_" + (app.app_id))
      }
    }, [_c('span'), _vm._v(" "), _c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    })])])])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "create-location-confirm",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
    attrs: {
      "steps": _vm.steps,
      "process": _vm.process
    }
  })], 1)])]) : _c('next-actions', {
    attrs: {
      "actionsList": _vm.createLocationNextActions
    },
    on: {
      "runFunction": _vm.runFunction
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\tCreate A Location\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b8778d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MyBusiness/Locations/CreateLocation.vue
// module id = 411
// module chunks = 1